import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import BackgroundImage from '../components/BackgroundImage';
import { getBackgroundImage } from '../selectors';
import { setBackground, setBackgroundImage } from '../actions';

const LogoContainer = compose(
  connect(
    state => ({
      value: getBackgroundImage(state),
    }),
    {
      setBackground,
      setBackgroundImage,
    }
  ),
  withHandlers({
    onChange: props => imageFile => props.setBackground(imageFile),
    onContentChange: props => imageUrl => props.setBackgroundImage(imageUrl),
    remove: props => () => {
      props.setBackground('');
      props.setBackgroundImage('');
    },
  })
)(BackgroundImage);

export default LogoContainer;
